import RenderRichTextContent from '@components/common/render-rich-text-content'
import classNames from 'classnames'

type Props = {
  solutionContent: string
  isPaused: boolean
}

const Solution = ({ solutionContent, isPaused }: Props) => (
  <div
    className={classNames(
      'flex flex-col items-center lg:justify-center py-5 px-5 mx-5 mb-5 h-full rounded-lg bg-black bg-opacity-50 duration-500',
      { 'opacity-0': isPaused }
    )}
  >
    <p className="font-600 text-lg lg:text-3xl my-5 lg:my-10">Explanation</p>
    <div className="flex items-center justify-center h-full lg:h-auto">
      <RenderRichTextContent
        content={solutionContent}
        className="text-center text-lg lg:text-2xl"
      />
    </div>
  </div>
)

export default Solution
